import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu\">\n    <!-- Generator: Sketch 56.3 (81716) - https://sketch.com -->\n    <title>编组</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-menu_页面-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-menu_画板\" transform=\"translate(-340.000000, -34.000000)\" fill=\"#FFFFFF\">\n            <g id=\"icon-menu_编组\" transform=\"translate(340.000000, 34.000000)\">\n                <rect id=\"icon-menu_矩形\" x=\"0\" y=\"0\" width=\"18\" height=\"2\" rx=\"1\" />\n                <rect id=\"icon-menu_矩形备份-4\" x=\"0\" y=\"6\" width=\"18\" height=\"2\" rx=\"1\" />\n                <rect id=\"icon-menu_矩形备份-5\" x=\"0\" y=\"12\" width=\"18\" height=\"2\" rx=\"1\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu.svg
// module id = dH9r
// module chunks = 4